import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Listens for SW_NAVIGATE messages from the service worker (push-click handler)
// and routes via React Router. Required on iOS PWAs where WindowClient.navigate
// is unreliable.
export function SwNavigateBridge() {
  const navigate = useNavigate();

  useEffect(() => {
    if (typeof navigator === "undefined" || !navigator.serviceWorker) return;
    const handler = (event: MessageEvent) => {
      if (event.data?.type === "SW_NAVIGATE" && typeof event.data.url === "string") {
        const target = event.data.url as string;
        if (target.startsWith("/")) {
          navigate(target);
        }
      }
    };
    navigator.serviceWorker.addEventListener("message", handler);
    return () => navigator.serviceWorker.removeEventListener("message", handler);
  }, [navigate]);

  return null;
}
